module.exports = __webpack_public_path__ + "img/film.2dc9fcdd.png";